var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isActive('href'))?_c('a',{attrs:{"href":_vm.link}},[_vm._t("default")],2):_vm._e(),(_vm.isActive('routerLink'))?_c('router-link',{attrs:{"to":_vm.link}},[_vm._t("default")],2):_vm._e(),(_vm.noneActive)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }